export const antTableRowColorGray = '#fafafa';
export const antTableRowColorWhite = '#fff';
export const antTableCategoryRowColorGray = '#f0f0f0';
export const screenerAntTableRowColorGray = '#FCFBFB';

export const calculateRowIndex = (rowIndex) => {
  return rowIndex % 2 === 0 ? 'ant-table-row-colo-white' : 'ant-table-row-color-gray';
};
export const overrideTableRows = (record, rowIndex, flag?: string | string[]) => {
  const getFlagedClassName = () => {
    let className = '';
    if (typeof flag !== 'string') {
      flag?.forEach((key) => {
        if (record[key]) {
          className = 'ant-table-category-row-color-gray catagory-bordar-botom';
        }
      });
    }

    return className;
  };

  return {
    className:
      typeof flag === 'object'
        ? getFlagedClassName().length
          ? 'ant-table-category-row-color-gray catagory-bordar-botom'
          : calculateRowIndex(rowIndex)
        : typeof flag === 'string'
        ? record[flag]
          ? 'ant-table-category-row-color-gray catagory-bordar-botom'
          : calculateRowIndex(rowIndex)
        : calculateRowIndex(rowIndex),
  };
};

export const overrideTableRowsClassName = (record, rowIndex) => {
  return {
    style: {},
  };
};

export const overrideCellColor = (index) => {
  return index % 2 === 0 ? antTableRowColorWhite : antTableRowColorGray;
};

export const overrideScreenerCellColor = (index) => {
  return index % 2 === 0 ? antTableRowColorWhite : screenerAntTableRowColorGray;
};
